<ngx-extended-pdf-viewer [src]="this.fileUrl.url" 
[height]="'100vh'" 
[useBrowserLocale]="true"
[textLayer]="true"
[showHandToolButton]="false"
[showPresentationModeButton]="false"  
[showDownloadButton]="true"
[showSidebarButton]="true"
[showBookmarkButton]="false"
[showFindButton]="false"
[showOpenFileButton]="false"
[showToolbar]="true"
[showSecondaryToolbarButton]="false"
[showSpreadButton]="true"

>
</ngx-extended-pdf-viewer>
<!-- <div id="pdf-div"></div> -->
<!-- <div [innerHTML]="innerHtml"></div>  -->